import { useConfig } from '../context/ConfigContext';
export var useManageWorkplaceServiceRequest = function (serviceRequestFormStatus) {
    var _a, _b;
    var _c = useConfig(), environmentUrls = _c.environmentUrls, userContext = _c.userContext;
    var dashboardUrl = environmentUrls.dashboardUrl;
    var orgSlug = (_b = (_a = userContext === null || userContext === void 0 ? void 0 : userContext.currentOrg) === null || _a === void 0 ? void 0 : _a.slug) !== null && _b !== void 0 ? _b : '';
    var formPath = (serviceRequestFormStatus === null || serviceRequestFormStatus === void 0 ? void 0 : serviceRequestFormStatus.type) === 'edit'
        ? "change-answers-form"
        : "request-form";
    var iframePath = orgSlug
        ? "".concat(dashboardUrl, "/").concat(orgSlug, "/tickets/").concat(formPath, "?use_parent_token=true")
        : '';
    // const iframePath = `http://localhost:3000/${orgSlug}/tickets/${formPath}?use_parent_token=true`;
    return {
        iframePath: iframePath,
        /* Work place services is enabled by default for everyone */
        workplaceServicesEnabled: true,
    };
};
